var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from "react";
import { useFormContext } from "react-hook-form";
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'uuid/v4'. '/Users/dkrajnak/workspace/aviso/sse-frontend/react/node_modules/uuid/v4.js' implicitly has an 'any' type.
import uuid from "uuid/v4";
import SendMessageActionEmailRecipientForm from "../../Message/SendMessageActionEmailRecipientForm";
import useService from "../../../Hooks/useService";
import MessageTemplateService from "../../../../Services/MessageTemplate.service";
import PersonService from "../../../../Services/Person.service";
import SMSForm from "../../Message/SMSForm";
import useHasPermission from "../../../Hooks/useHasPermission";
import CheckboxField from "../../../Form/CheckboxField";
import SendMessageAsNoteForm from "../../Message/SendMessageAsNoteForm";
import NoteTypeService from "../../../../Services/NoteType.service";
export const CREATE_SMS_GET_CRITERIA = (formState, { exportNodeId, pipelineId }) => {
    var _a;
    const PERSON_LOADER_DELEGATE_ID = uuid();
    const personLoaderDelegate = {
        id: PERSON_LOADER_DELEGATE_ID,
        type: "PersonLoader",
        criteria: {
            personId: {
                isReference: true,
                workflowNodeReferenceId: exportNodeId,
                propertyName: "studentId",
            },
        },
    };
    const OPPORTUNITY_LOADER_DELEGATE_ID = uuid();
    const opportunityLoaderDelegate = {
        id: OPPORTUNITY_LOADER_DELEGATE_ID,
        type: "OpportunityLoader",
        criteria: {
            subjectId: {
                isReference: true,
                workflowNodeReferenceId: exportNodeId,
                propertyName: "studentId",
            },
            pipelineId: {
                isReference: false,
                value: pipelineId,
            },
        },
    };
    return {
        delegates: [personLoaderDelegate, opportunityLoaderDelegate],
        criteria: {
            smsBody: { value: formState.smsBody, isReference: false },
            // @ts-expect-error - TS2339 - Property 'isReference' does not exist on type 'PersonLite | { isReference: true; }'.
            recipientAffiliationId: formState.recipient.isReference
                ? {
                    isReference: true,
                    workflowNodeReferenceId: PERSON_LOADER_DELEGATE_ID,
                    propertyName: "affiliationId",
                }
                : {
                    // @ts-expect-error - TS2339 - Property 'affiliationId' does not exist on type 'PersonLite | { isReference: true; }'.
                    value: formState.recipient.affiliationId,
                    isReference: false,
                },
            // @ts-expect-error - TS2339 - Property 'isReference' does not exist on type 'PersonLite | { isReference: true; }'.
            senderAffiliationId: formState.sender.isReference
                ? {
                    isReference: true,
                    workflowNodeReferenceId: OPPORTUNITY_LOADER_DELEGATE_ID,
                    propertyName: "assignedPersonAffiliationId",
                }
                : {
                    // @ts-expect-error - TS2339 - Property 'affiliationId' does not exist on type 'PersonLite | { isReference: true; }'.
                    value: formState.sender.affiliationId,
                    isReference: false,
                },
            logMessage: { value: formState.logMessage, isReference: false },
            saveMessageAsNote: {
                value: formState.noteFromMessage,
                isReference: false,
            },
            noteTypeIds: {
                value: (_a = formState.selectedNoteTypes) === null || _a === void 0 ? void 0 : _a.map((noteType) => noteType.id),
                isReference: false,
            },
            pipelineId: {
                propertyName: "pipelineId",
                isReference: true,
                workflowNodeReferenceId: OPPORTUNITY_LOADER_DELEGATE_ID,
            },
            opportunityId: {
                isReference: true,
                propertyName: "opportunityId",
                workflowNodeReferenceId: OPPORTUNITY_LOADER_DELEGATE_ID,
            },
        },
    };
};
// @ts-expect-error - TS2322 - Type '(criteria: { recipientAffiliationId: WorkflowGroupNodeCriteriaProperty; senderAffiliationId: WorkflowGroupNodeCriteriaProperty; smsBody: WorkflowGroupNodeCriteriaProperty; logMessage: WorkflowGroupNodeCriteriaProperty; saveMessageAsNote: WorkflowGroupNodeCriteriaProperty; noteTypeIds: WorkflowGroupNodeCriteriaProper...' is not assignable to type 'GetFormState<{ recipientAffiliationId: WorkflowGroupNodeCriteriaProperty; senderAffiliationId: WorkflowGroupNodeCriteriaProperty; smsBody: WorkflowGroupNodeCriteriaProperty; logMessage: WorkflowGroupNodeCriteriaProperty; saveMessageAsNote: WorkflowGroupNodeCriteriaProperty; noteTypeIds: WorkflowGroupNodeCriteriaProp...'.
export const CREATE_SMS_GET_FORM_STATE = (criteria) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    // We need to load in the sender and the recipient
    const [sender, recipient, selectedNoteTypes] = yield Promise.all([
        // sender
        criteria.senderAffiliationId.isReference
            ? Promise.resolve({
                isReference: true,
                affiliationId: null,
            })
            : PersonService.peopleFromAffiliationIds([
                (_a = criteria.senderAffiliationId) === null || _a === void 0 ? void 0 : _a.value,
            ]).then((people) => people[0]),
        // recipient -- this could be a reference.  If it is, we just hard code it for now
        criteria.recipientAffiliationId.isReference
            ? Promise.resolve({
                isReference: true,
                affiliationId: null,
            })
            : PersonService.peopleFromAffiliationIds([
                criteria.recipientAffiliationId.value,
            ]).then((people) => people[0]),
        ((_b = criteria.noteTypeIds) === null || _b === void 0 ? void 0 : _b.value)
            ? NoteTypeService.findByIds(criteria.noteTypeIds.value)
            : Promise.resolve(null),
    ]);
    return {
        recipient,
        sender,
        smsBody: criteria.smsBody.value,
        logMessage: criteria.logMessage.value,
        noteFromMessage: !!(selectedNoteTypes === null || selectedNoteTypes === void 0 ? void 0 : selectedNoteTypes.length),
        selectedNoteTypes,
    };
});
const CreateSmsWorkflowNodeDefinitionForm = ({ name, }) => {
    const formProps = useFormContext();
    const [personalizationMenuState, loadPersonalizationMenus] = useService(MessageTemplateService.getPersonalizationMenusForPipelineCreateSMSNode);
    useEffect(() => {
        loadPersonalizationMenus();
    }, [loadPersonalizationMenus]);
    const hasLoggingPermission = useHasPermission("CAN_LOG_MESSAGES");
    return (_jsxs(_Fragment, { children: [_jsx(SendMessageActionEmailRecipientForm, Object.assign({}, formProps, { name: name })), _jsx(SMSForm, Object.assign({}, formProps, { personalizationMenus: personalizationMenuState, name: name })), hasLoggingPermission && (_jsx("div", { className: "form-group", children: _jsx(CheckboxField, { label: "Log Message", name: name + ".logMessage", helpText: "If a student is the recipient of this message, show this message in their Messages and Activity tabs.\n              Logged messages will be stored on the student profile regardless of the delivery status." }) })), _jsx(SendMessageAsNoteForm, Object.assign({ name: name }, formProps))] }));
};
export default CreateSmsWorkflowNodeDefinitionForm;
